export default __webpack_public_path__ + "static/media/No.5-3.82e752d8.jpg";